

import axios from "axios"

import store from "@/store"

import Cookie from "js-cookie"

import { Message } from 'element-ui'

const TOKEN_NAME = 'grading-token'

const request = axios.create({
    baseURL: process.env.VUE_APP_PREFIX,
    withCredentials: true,

})

request.interceptors.request.use(
    config => {
        if (Cookie.get(TOKEN_NAME)) {
            config.headers['Api-Token'] = Cookie.get(TOKEN_NAME)

        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
);



// response拦截器, 处理response
request.interceptors.response.use(
    response => {
        return response.data
    },
    error => {
        if (error.response.status === 401) {
            store.dispatch('logout');
        } else {
            Message({
                message: error.message,
                type: 'error',
                duration: 5 * 1000
            })
            return Promise.reject(error)
        }


    }
);



export default request;